import { Backdrop, BackdropProps } from '@mui/material';

export function MuiBackdrop(props: BackdropProps) {
  return <Backdrop {...props} />;
}
